import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

export const useGetSettingsActive = () => {
  const location = useLocation()

  const isSettingsMode = useMemo(
    () => location.pathname.startsWith('/settings'),
    [location.pathname],
  )
  const isSettingsHomePage = useMemo(
    () => location.pathname === '/settings/home',
    [location.pathname],
  )
  const currentLocation = useMemo(
    () => `${location.pathname}${location.search || ''}`,
    [location.pathname, location.search],
  )

  return { isSettingsMode, isSettingsHomePage, currentLocation }
}
